import React, { useEffect } from 'react';
import useAppStore from '../../store/appStore';

const PRIORITY_LABELS = ['', 'Low', 'Below avg', 'Medium', 'High', 'Critical'];
const PRIORITY_COLORS = ['', '#64748b', '#64748b', '#f59e0b', '#f97316', '#ef4444'];

export default function GoalsPanel() {
  const goals = useAppStore(s => s.goals);
  const loadGoals = useAppStore(s => s.loadGoals);
  const atomStats = useAppStore(s => s.atomStats);

  useEffect(() => {
    loadGoals();
  }, [loadGoals]);

  const goalDomainAtoms = atomStats.by_domain || {};

  return (
    <div className="goals-panel">
      <div className="panel-header">
        <h2>Goals</h2>
        <span className="atom-count">{goals.length} active</span>
      </div>

      {goals.length === 0 ? (
        <div className="empty-state">
          No goals yet. Tell ASI:Mind about your goals in the chat.
          <br />
          <em>e.g. "My goal is to become CPO at an AGI company within 3 years"</em>
        </div>
      ) : (
        <div className="goals-list">
          {goals.map((goal, i) => (
            <GoalCard key={goal.name || i} goal={goal} />
          ))}
        </div>
      )}

      {/* Domain breakdown */}
      <div className="domain-breakdown">
        <div className="panel-section-title">Knowledge Graph</div>
        {Object.entries(goalDomainAtoms)
          .filter(([d]) => d !== 'meta')
          .sort(([, a], [, b]) => b - a)
          .map(([domain, count]) => (
            <DomainBar key={domain} domain={domain} count={count}
              max={Math.max(...Object.values(goalDomainAtoms))} />
          ))}
      </div>
    </div>
  );
}

function GoalCard({ goal }) {
  const meta = goal.metadata || {};
  const priority = meta.priority || 3;
  const status = meta.status || 'active';
  const tv = goal.truth_value || {};

  return (
    <div className="goal-card">
      <div className="goal-header">
        <span
          className="goal-priority"
          style={{ color: PRIORITY_COLORS[priority] }}
          title={`Priority: ${PRIORITY_LABELS[priority]}`}
        >
          {'●'.repeat(priority)}{'○'.repeat(5 - priority)}
        </span>
        <span className={`goal-status ${status}`}>{status}</span>
      </div>
      <div className="goal-name">{goal.name}</div>
      {meta.timeline && (
        <div className="goal-meta">Timeline: {meta.timeline}</div>
      )}
      {tv.confidence !== undefined && (
        <div className="goal-confidence">
          <div className="confidence-bar">
            <div
              className="confidence-fill"
              style={{ width: `${(tv.confidence || 0) * 100}%` }}
            />
          </div>
          <span className="confidence-label">{((tv.confidence || 0) * 100).toFixed(0)}% confidence</span>
        </div>
      )}
    </div>
  );
}

function DomainBar({ domain, count, max }) {
  const pct = max > 0 ? (count / max) * 100 : 0;
  const COLORS = {
    health: '#10b981', finance: '#f59e0b', career: '#3b82f6',
    relationships: '#ec4899', goals: '#8b5cf6', habits: '#14b8a6',
    events: '#64748b', family: '#f97316',
  };

  return (
    <div className="domain-bar-row">
      <span className="domain-label" style={{ color: COLORS[domain] || '#94a3b8' }}>
        {domain}
      </span>
      <div className="bar-track">
        <div
          className="bar-fill"
          style={{ width: `${pct}%`, background: COLORS[domain] || '#475569' }}
        />
      </div>
      <span className="domain-count">{count}</span>
    </div>
  );
}
